
import React from "react";
import { connect } from 'react-redux';
import { Redirect, Route } from "react-router-dom";
import SafeRoute from './SafeRoute';
import userSession from '../../utils/userSession';

const PrivateRoute = ({ component: Component, auth, children = null, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const userId = userSession('id');
      const state = {};

      if (props.location.pathname !== '/') {
        state.from = props.location.pathname;
      }

      if (auth.user && (auth.user.email == "tester+facebook@obvious.ly" || auth.user.email == "max+facebooktester@obvious.ly")) {
        if (!auth.user.social.inst.nickname) {
          window.location.href = '/users/facebook/insights'
        } else {
          window.location.href = '/users/facebook/pages?step=oauth';
        }
        return;
      }

      if (auth.isInfluencerWithOfferAccessToken) {
        return <SafeRoute {...props}
          children={children}
          component={Component}
          user={auth.user} />
      }

      return ((auth.loading || auth.user) && userId)
        ? <SafeRoute {...props} children={children} component={Component} user={auth.user} />
        : <Redirect
          to={{
            pathname: "/signin",
            state
          }}
        />;

    }}
  />
);
const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps)(PrivateRoute);
